import * as React from 'react';

import SkillMapMain from '../../components/SkillMap';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * マップ表示画面
 * @param props
 */
const SkillMap: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('SkillMap_0018')} />
			<SkillMapMain cmId={props.match.params.cmid} AdminView={false} />
		</>
	);
};

export default SkillMap;



// WEBPACK FOOTER //
// ./src/pages/personal/SkillMap.tsx